<template>
  <div class="deeplink-modal" v-show="show">
    <div class="deeplink-modal-box">
      <div class="deeplink-modal-header">
        提示

        <close-btn class="deeplink-modal-close" @click="handleHide"></close-btn>
      </div>
      <div class="deeplink-modal-content" ref="content">
        <div class="deeplink-modal-error-tips" v-show="isError">
          网络原因，加载失败，请关闭重试。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wpsoffice from '@wps/wps_client_api/wpsoffice';

export default {
  data() {
    return {
      show: false,
      iframeLoaded: false,
      isError: false,
      lock: false,

      url: '',
    };
  },

  watch: {
    show(val) {
      if (!val) {
        this.closeIFrame();
      }
    },
    /**
     * ie浏览器下，iframe onload事件会最先触发，然后才会接受到postmessgae消息
     * 因此需要监听iframeLoaded，当postmessgae返回loaded时，修改页面错误状态
     */
    iframeLoaded(val) {
      if (val) {
        this.isError = false;
        this.iframe.style.display = 'block';
      }
    },
  },

  methods: {
    handleHide() {
      this.show = false;
      this.$emit('close');
    },

    // 绑定监听postMessage
    initMessage() {
      this._messageHandler = this.messageHandler.bind(this);
      window.addEventListener('message', this._messageHandler, false);
    },

    // 移除监听postMessage
    removeMessage() {
      window.removeEventListener('message', this._messageHandler, false);
    },

    // 监听postMessage
    messageHandler(event) {
      if (
        event.origin !== 'http://dk.u.wps.cn' &&
        event.origin !== 'https://dk.u.wps.cn'
      ) {
        return;
      }
      if (event.data === 'close') {
        this.closeIFrame();
      }
      if (event.data === 'failed') {
        // 唤醒失败暂无处理
      }
      // if (event.data === 'ok') {
      //   this.closeIFrame();
      // }

      if (event.data === 'loaded') {
        this.iframeLoaded = true;
      }
    },

    // 处理url需要的参数
    initUrlParams(url) {
      return new Promise((resolve) => {
        url +=
          '&iframe=' +
          encodeURIComponent(
            window.location.protocol + '//' + window.location.host
          );
        if (!!window.cefQuery) {
          wpsoffice.getAppInfo().then((res) => {
            if (res && res.version) {
              url += `&version=${res.version}`;
            }
            resolve(url);
          });
        } else {
          resolve(url);
        }
      });
    },

    initIframe(url) {
      this.iframe = document.createElement('iframe');
      this.iframe.name = 'iframe';
      this.iframe.src = url;
      // 如果iframe的onload触发后，还没有收到postMessage的load事件，则认为加载失败
      this.iframe.onload = () => {
        if (!this.iframeLoaded) {
          this.isError = true;
          this.iframe.style.display = 'none';
        }
      };

      this.$refs.content.appendChild(this.iframe);
    },

    // 关闭iframe
    closeIFrame() {
      this.$refs.content.removeChild(this.iframe);
      this.iframe = null;
      this.lock = false;
      this.removeMessage();
    },

    async wakeup(url) {
      if (this.lock) {
        return false;
      }
      this.lock = true;

      url = await this.initUrlParams(url);
      this.initIframe(url);
      this.initMessage();

      this.show = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.deeplink-modal {
  @include popup-style(99);

  &-box {
    height: 500px;
    width: 600px;
    background-color: #ffffff;
    border: 1px solid #e8e8e8;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 2px 0 8px 4px rgb(46 61 73 / 20%);
  }

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 16px;
    padding: 16px 0;
    border-bottom: 1px solid #e8e8e8;
    line-height: 28px;
    height: 60px;
    font-weight: 900;
    font-size: 18px;
  }
  &-close {
    display: block;
  }

  &-content {
    position: relative;
  }

  &-error-tips {
    display: flex;
    position: absolute;
    top: 50px;
    left: 0px;
    color: #666666;
    font-size: 18px;
    width: 100%;
    height: 300px;
    justify-content: center;
    align-items: center;
  }
}
</style>

<style lang="scss">
.deeplink-modal-content {
  > iframe {
    width: 100%;
    border: 0px solid #ffffff;
    height: 440px;
  }
}
</style>
